export default {
  banner: {
    documentAlt: 'Document Icon',
    stepsToPrepare: 'Two easy steps to prepare for tax season',
    submitYourInfo: 'Submit your tax information',
    request1099: 'Request Form 1099-K',
    step1Alt: 'Step 1',
    step2Alt: 'Step 2',
    explanationHtml: 'If you sell more than $600 in a calendar year, your tax info is needed so we can issue you a Form 1099-K. {{children}}',
  },
  footer: {
    speakerAlt: 'Speaker Icon',
    shieldAlt: 'Shield Icon',
    doINeedToProvideInfoHeader: 'Do I need to provide my tax info?',
    doINeedToProvideInfoParagraph1: 'For sales made in {{previousYear}}, Reverb is required to collect tax identification information from US sellers who exceed the federal threshold of $20,000 in sales and 200 transactions or live in a state with a lower reporting threshold. You can {{children}}',
    doINeedToProvideInfoLearnMore1: 'learn more about {{previousYear}} US tax reporting requirements here.',
    doINeedToProvideInfoParagraph2: 'This tax information is needed to issue you a Form 1099-K. Once you\'ve provided your tax information, we\'ll reach out to you on any next steps—including when your Form 1099-K is ready to download. Note that reporting your sales doesn\'t necessarily mean you\'ll need to pay income tax on your sales.',
  },
  tinVerification: {
    incomplete: 'Incomplete',
    complete: 'Complete',
    pending: 'Pending',
  },
  taxForms: {
    comingSoon: 'Coming soon: if you exceeded federal or state tax reporting thresholds in {{prevYear}}, your Form 1099-K will be available here at the end of January {{currYear}}.',
    noFormsAvailable: 'No tax forms available. You didn\'t meet the 1099-K reporting threshold for {{prevYear}}.',
    downloadTaxForm: 'Download',
    failure: 'Something went wrong downloading your tax form.  Please try again.',
    loading: 'Fetching Form...',
    requestDownload: 'Request Form',
    requested: 'Form 1099-K successfully requested! A download link to your Form 1099-K will be available below shortly.',
    secureDownload: 'For your security, this link will expire after 24 hours.',
    title: 'Request Form 1099-K',
    description: 'If you prefer a paper Form 1099-K mailed to you, please email {{children}}.',
    emailLinkText: '1099taxreporting@reverb.com',
    downloadIncompleteStatus: 'Incomplete',
    downloadRequestedStatus: 'Last requested on {{date}}',
    downloadNotYetRequested: 'This form has not been requested yet.',
    taxYear: 'Tax Year',
    taxYearStatus: 'Status',
  },
  helpCenterLinkText: 'Learn more in our Help Center.',
  taxProfileForm: {
    tinFailedVerificationHeadline: 'Important: Updated tax info needed',
    tinFailedVerificationMessage: 'Your TIN was not able to be verified. Please double check that the information you provided matches what you used to file your taxes.',
  },
};
